<template>
    <tbody class="offer-tbody">
        <tr>
            <td>
                <v-select
                    :items="productTypes"
                    item-value="id"
                    item-text="text"
                    v-model="internalValue.type"
                    :error-messages="errorMessages(`products.${index}.type`)"
                    :class="{ 'error--text': hasErrors(`products.${index}.type`) }"
                    class="primary--text"
                    :name="`products.${index}.type`"
                    label="Tip produs"
                    data-vv-as="Tip produs"
                    :data-vv-name="`products.${index}.type`"
                />
            </td>
            <td>
                <product-combo-box
                    v-model="internalValue.id"
                    :initial-items="[internalValue]"
                    :field-errors="errorMessages(`products.${index}.name`)"
                    :product-class="() => $db.ConstructionEstimateProduct"
                    @change="handleProductLineChange($event)"
                />
            </td>
            <td v-if="hasDates">
                <v-offer-row-field
                    v-model="internalValue.item_date"
                    :error-messages="errorMessages(`products.${index}.item_date`)"
                    :class="{ 'primary--text input-text-right':true, 'error--text': hasErrors(`products.${index}.item_date`) }"
                    data-vv-as="Data"
                    :data-vv-name="`products.${index}.item_date`"
                />
            </td>
            <td>
                <v-offer-row-field
                    v-model="internalValue.quantity"
                    :error-messages="errorMessages(`products.${index}.quantity`)"
                    :class="{ 'primary--text input-text-right':true, 'v-input--is-disabled': isComplex, 'error--text': hasErrors(`products.${index}.quantity`) }"
                    data-vv-as="Cantitate"
                    :data-vv-name="`products.${index}.quantity`"
                    type="number"
                />
            </td>
            <td>
                <v-select
                    :items="productMeasurements"
                    v-model="internalValue.measurement"
                    :error-messages="errorMessages(`products.${index}.measurement`)"
                    :class="{ 'error--text': hasErrors(`products.${index}.measurement`) }"
                    class="primary--text input-text-right"
                    :name="`products.${index}.measurement`"
                    label="U.M."
                    data-vv-as="U.M."
                    :data-vv-name="`products.${index}.measurement`"
                />
            </td>
            <td>
                <v-offer-row-field
                    v-model="internalValue.unit_price"
                    :error-messages="errorMessages(`products.${index}.unit_price`)"
                    :class="{ 'primary--text input-text-right':true, 'v-input--is-disabled': isComplex, 'error--text': hasErrors(`products.${index}.unit_price`) }"
                    data-vv-as="PU ofertat"
                    :data-vv-name="`products.${index}.unit_price`"
                    type="number"
                />
            </td>
            <td>
                <v-offer-row-field
                    v-model="internalValue.unit_price_with_vat"
                    :error-messages="errorMessages(`products.${index}.unit_price_with_vat`)"
                    :class="{ 'primary--text input-text-right':true, 'v-input--is-disabled': isComplex, 'error--text': hasErrors(`products.${index}.unit_price_with_vat`) }"
                    data-vv-as="PU ofertat cu TVA"
                    :data-vv-name="`products.${index}.unit_price_with_vat`"
                    type="number"
                />
            </td>
            <td>
                <v-btn
                    :disabled="!canEdit"
                    class="ma-2 pull-right"
                    color="error"
                    outlined
                    x-small
                    fab
                    @click="$emit('delete')"
                >
                    <v-icon>mdi-trash-can</v-icon>
                </v-btn>
                <v-btn
                    v-if="canEdit && isComplex"
                    class="ma-2 pull-right"
                    color="warning"
                    outlined
                    x-small
                    fab
                    @click="$emit('addChild', { index: index, type: 'simple' })"
                >
                    <v-icon>mdi-plus-circle</v-icon>
                </v-btn>
            </td>
        </tr>
        <tr>
            <td :colspan="hasDates ? 7 : 6">
                <v-offer-row-field
                    v-model="internalValue.remarks"
                    :error-messages="errorMessages(`products.${index}.remarks`)"
                    :class="{ 'primary--text input-text-right':true, 'error--text': hasErrors(`products.${index}.remarks`) }"
                    data-vv-as="Observatii"
                    :data-vv-name="`products.${index}.remarks`"
                />
            </td>
            <td></td>
        </tr>
        <tr
            v-if="internalValue.children instanceof Array && internalValue.children.length > 0"
            v-for="(child, childIndex) in internalValue.children"
            :key="`child-${internalValue.id}-${childIndex}`"
        >
            <td>
            </td>
            <td :colspan="hasDates ? 2 : 1">
                <product-combo-box
                    v-model="child.id"
                    :initial-items="[child]"
                    :initial-items-needs-to-have-id="false"
                    :field-errors="errorMessages(`products.${index}.children.${childIndex}.name`)"
                    :product-class="() => $db.ConstructionEstimateProduct"
                    @change="handleProductLineChildChange($event, childIndex)"
                />
            </td>
            <td>
                <v-offer-row-field
                    v-model="child.quantity"
                    :error-messages="errorMessages(`products.${index}.children.${childIndex}.quantity`)"
                    :class="{ 'primary--text input-text-right':true, 'error--text': hasErrors(`products.${index}.children.${childIndex}.quantity`) }"
                    data-vv-as="Cantitate"
                    :data-vv-name="`products.${index}.children.${childIndex}.quantity`"
                    type="number"
                />
            </td>
            <td>
                <v-select
                    :items="productMeasurements"
                    v-model="child.measurement"
                    :error-messages="errorMessages(`products.${index}.children.${childIndex}.measurement`)"
                    :class="{ 'error--text': hasErrors(`products.${index}.children.${childIndex}.measurement`) }"
                    class="primary--text input-text-right"
                    :name="`products.${index}.children.${childIndex}.measurement`"
                    label="U.M."
                    data-vv-as="U.M."
                    :data-vv-name="`products.${index}.children.${childIndex}.measurement`"
                />
            </td>
            <td>
                <v-offer-row-field
                    v-model="child.unit_price"
                    :error-messages="errorMessages(`products.${index}.children.${childIndex}.unit_price`)"
                    :class="{ 'primary--text input-text-right':true, 'error--text': hasErrors(`products.${index}.children.${childIndex}.unit_price`) }"
                    data-vv-as="PU ofertat"
                    :data-vv-name="`products.${index}.children.${childIndex}.unit_price`"
                    type="number"
                />
            </td>
            <td>
                <v-offer-row-field
                    v-model="child.unit_price_with_vat"
                    :error-messages="errorMessages(`products.${index}.children.${childIndex}.unit_price_with_vat`)"
                    :class="{ 'primary--text input-text-right v-input--is-disabled':true, 'error--text': hasErrors(`products.${index}.children.${childIndex}.unit_price_with_vat`) }"
                    data-vv-as="PU ofertat cu TVA"
                    :data-vv-name="`products.${index}.children.${childIndex}.unit_price_with_vat`"
                    :disabled="true"
                    type="number"
                />
            </td>
            <td>
                <v-btn
                    :disabled="!canEdit"
                    class="ma-2 pull-right"
                    color="error"
                    outlined
                    x-small
                    fab
                    @click="deleteChild(childIndex)"
                >
                    <v-icon>mdi-trash-can</v-icon>
                </v-btn>
            </td>
        </tr>
    </tbody>
</template>

<script>
import ProductComboBox from 'Components/modal/ProductComboBox'
import VOfferRow from 'Components/common/VOfferRow'
export default {
    name: 'VConstructionEstimateRow',
    extends: VOfferRow,
    components: {
        ProductComboBox
    },
    props: {
        value: {
            type: Object,
            default() {
                return {
                    id: null,
                    type: null,
                    name: null,
                    quantity: 1,
                    measurement: 'BUC',
                    unit_price: 0,
                    unit_price_with_vat: 0,
                    children: [],
                    remarks: null
                }
            }
        },
        index: {
            type: Number,
            default() {
                return null
            }
        },
        canEdit: {
            type: Boolean,
            default() {
                return true
            }
        },
        hasErrors: {
            type: Function,
            default () {
                return () => {

                }
            }
        },
        errorMessages: {
            type: Function,
            default () {
                return () => {

                }
            }
        },
        hasDates: {
            type: Boolean,
            default () {
                return false
            }
        }
    },
    computed: {
        isComplex () {
            return this.internalValue.type === 'complex'
        }
    },
    watch: {
        value: {
            handler (val) {
                this.internalValue = val
            },
            deep: true
        },
        'internalValue.unit_price': {
            handler (val) {
                this.internalValue.unit_price_with_vat = (parseFloat(val) * this.$db.Invoice.VAT_RATE_MULTIPLIER).toFixed(2)
            }
        },
        'internalValue.unit_price_with_vat': {
            handler (val) {
                this.internalValue.unit_price = (parseFloat(val) / this.$db.Invoice.VAT_RATE_MULTIPLIER).toFixed(2)
            }
        },
        'internalValue.type': {
            handler(val) {
                if (val !== 'complex') {
                    this.internalValue.children = []
                } else {
                    this.internalValue.quantity = 1
                }
            }
        },
        'internalValue.children': {
            handler(val, oldVal) {
                if (this.isComplex) {

                    val.forEach((item, index) => {
                        val[index].unit_price_with_vat = (parseFloat(val[index].unit_price) * this.$db.Invoice.VAT_RATE_MULTIPLIER).toFixed(2)
                    })

                    this.internalValue.quantity = 1
                    this.internalValue.unit_price = this._.sumBy(
                        val, (product) => {
                            return parseFloat(product.quantity) * parseFloat(product.unit_price)
                        }
                    )
                }
            },
            deep: true
        },
        internalValue: {
            handler (val) {
                this.$emit('input', val)
            },
            deep: true
        }
    },
    data () {
        return {
            internalValue: this.value,
            productTypes: [],
            productMeasurements: [],
        }
    },
    methods: {
        handleProductLineChange(ev) {
            if (!this._.isNil(ev)) {
                if (ev instanceof Object) {
                    this.internalValue.id = ev.id
                    this.internalValue.type = ev.type
                    this.internalValue.name = ev.name
                } else {
                    if (!this._.isNil(this.internalValue.id)) {
                        this.internalValue.id = null
                        this.internalValue.type = null
                    }
                    this.internalValue.name = ev
                }
                this.$validator.reset();
                this.$validator.validateAll()
            }
        },
        handleProductLineChildChange(ev, index) {
            if (!this._.isNil(ev)) {
                if (ev instanceof Object) {
                    this.internalValue.children[index].id = ev.id
                    this.internalValue.children[index].type = ev.type
                    this.internalValue.children[index].name = ev.name
                } else {
                    if (!this._.isNil(this.internalValue.children[index].id)) {
                        this.internalValue.children[index].id = null
                        this.internalValue.children[index].type = null
                    }
                    this.internalValue.children[index].name = ev
                }
                this.$validator.reset();
                this.$validator.validateAll()
            }
        },
        deleteChild(childIndex) {
            this.internalValue.children.splice(childIndex, 1)
        }
    },
    async mounted() {
        this.productMeasurements = (new this.$db.ConstructionEstimateProduct).measurements
        this.productTypes = (new this.$db.ConstructionEstimateProduct).productTypes
    }
    /*
    beforeUpdate() {
        console.log('beforeUpdate', this.index)
    },
    updated() {
        console.log('updated', this.index)
    }
    */
}
</script>
